import {
  AccessibilityStatement,
  ACCESSIBILITY_STATEMENT_META,
} from "./AccessibilityStatement";
import { CookiePolicy, COOKIE_POLICY_META } from "./CookiePolicy";
import { HipaaSecurity, HIPAA_SECURITY_META } from "./HipaaSecurity";
import { MessagingTerms, MESSAGING_TERMS_META } from "./MessagingTerms";
import { PrivacyPolicy, PRIVACY_POLICY_META } from "./PrivacyPolicy";
import { TermsOfService, TERMS_OF_SERVICE_META } from "./TermsOfService";
import type { LegalDoc } from "./types";

// Order shown in /legal tabs.
export const LEGAL_DOCS: readonly LegalDoc[] = [
  { ...PRIVACY_POLICY_META, Component: PrivacyPolicy },
  { ...TERMS_OF_SERVICE_META, Component: TermsOfService },
  { ...HIPAA_SECURITY_META, Component: HipaaSecurity },
  { ...COOKIE_POLICY_META, Component: CookiePolicy },
  { ...MESSAGING_TERMS_META, Component: MessagingTerms },
  { ...ACCESSIBILITY_STATEMENT_META, Component: AccessibilityStatement },
];

export { LegalLayout } from "./LegalLayout";
export {
  AccessibilityStatement,
  ACCESSIBILITY_STATEMENT_META,
  CookiePolicy,
  COOKIE_POLICY_META,
  HipaaSecurity,
  HIPAA_SECURITY_META,
  MessagingTerms,
  MESSAGING_TERMS_META,
  PrivacyPolicy,
  PRIVACY_POLICY_META,
  TermsOfService,
  TERMS_OF_SERVICE_META,
};
export type { DocMeta, LegalDoc, Section } from "./types";
